import { React, useState } from 'react';
import {
    createStyles,
    Text,
    Avatar,
    Group,
    TypographyStylesProvider,
    Paper,
    Textarea,
    Button,
    Card,
    Tabs
} from '@mantine/core';
import{
    IconGavel,
    IconMessage,
    IconFileReport,
    IconArticle,
    IconNotes
} from '@tabler/icons';
import koenigsegg from '../assets/koenigsegg.jpg';


import { CarCardDetsTable } from '../components/CarCardDetsTable';
import { CarCardDetsArticle } from '../components/CarCardDetsArticle';

const useStyles = createStyles((theme) => ({
    comment: {
        padding: `${theme.spacing.lg}px ${theme.spacing.xl}px`,
        //width: "inherit"
    },
    defPadding: {
        padding: "8px"
    },
    commentBtn: {
        marginLeft: "4%",
        marginBottom: "3%",
        
    },
    body: {
        paddingLeft: 54,
        paddingTop: theme.spacing.sm,
        fontSize: theme.fontSizes.sm,
    },
    displayArea: {
        width: "85%",
        margin: "0 auto"
    },
    panelArea: {
        //alignContent: "center",
        margin: "0 auto",
        alignItems: 'center',
    },

    content: {
        '& > p:last-child': {
            marginBottom: 0,
        },
    },
}));

let authHold = {
    src: koenigsegg,
    name: "John Does"
}

//descript: stats, article, & hightlights
//needed: use redux or props?
export function CarCardDetsTabNavA() {
    const { classes } = useStyles();
    const [activeTab, setActiveTab] = useState('stats');
    return (
        <>
            <Tabs
                value={activeTab}
                onTabChange={setActiveTab}
                className={classes.displayArea}>
                <Tabs.List>
                    <Tabs.Tab value="stats" icon={<IconFileReport size={14} />}>Stats</Tabs.Tab>
                    <Tabs.Tab value="second" icon={<IconArticle size={14} />}>Article</Tabs.Tab>
                    <Tabs.Tab value="third" icon={<IconNotes size={14} />}>Highlights</Tabs.Tab>
                </Tabs.List>

                <Tabs.Panel value="stats">
                    <CarCardDetsTable />
                </Tabs.Panel>
                <Tabs.Panel className={classes.panelArea} value="second">
                    <CarCardDetsArticle />
                </Tabs.Panel>
                <Tabs.Panel className={classes.panelArea} value="third">
                    <p>
                    bullet list items will be here<br/>
                    </p>
                </Tabs.Panel>
            </Tabs>
        </>
    );
}
